const selectors = {
  shoppableTarget: '[data-shoppable-target]',
  shoppableProduct: '[data-shoppable-product]',
};

export default class DynamicMediaWithText {
  constructor(section) {
    this.el = section.el;
    this.initShoppableImage();
  }

  initShoppableImage() {
    const shoppableTargets = this.el.querySelectorAll(
      selectors.shoppableTarget,
    );
    this.shoppableProducts = this.el.querySelectorAll(
      selectors.shoppableProduct,
    );

    /** Handles clicks/touches outside to hide the products */
    const handleOutsideInteraction = e => {
      if (!e.target.closest(selectors.shoppableTarget)) {
        this.hideAllProducts();
      }
    };

    document.addEventListener('click', handleOutsideInteraction);
    document.addEventListener('touchstart', handleOutsideInteraction);

    /** Handles clicks/touches on shoppable targets to show the shoppable product */
    const handleTargetInteraction = (e, index) => {
      e.preventDefault();
      e.stopPropagation();

      /** Hide all products */
      this.hideAllProducts();

      /** Show the clicked/touched product */
      const product = this.shoppableProducts[index];
      if (product) product.classList.remove('hidden');
    };

    /** Add event listeners to shoppable targets */
    shoppableTargets.forEach((target, index) => {
      target.addEventListener('click', e => handleTargetInteraction(e, index));
      target.addEventListener('touchstart', e =>
        handleTargetInteraction(e, index),
      );
    });
  }

  hideAllProducts() {
    this.shoppableProducts.forEach(product => {
      product.classList.add('hidden');
    });
  }

  onSectionUnload() {
    if (this.video) {
      this.video.unload();
    }

    if (this.playPauseObserver) {
      this.playPauseObserver.disconnect();
    }
  }
}
